<template>
    <v-card min-width="25vw" align="center" justify="center" light outlined>
        <v-card-title style="background-color: #fff75f">
            <v-list-item>
                <v-list-item-title><h2>{{ $t('title') }}</h2></v-list-item-title>
                <v-spacer/>
                <v-list-item-action v-if="!(brokerProblem || assetProblem)"><v-icon class="icon" @click="closeWindow" icon>fa-times</v-icon></v-list-item-action>
            </v-list-item>
        </v-card-title>
        <v-card-text class="px-7 py-7">
          <h1 class="d-flex justify-center no-trades mb-10">:(</h1>
          <p v-if="brokerProblem"><font v-html="$t('notBrokerAccount')"/>
            <a class="ml-1" href="https://app.swiset.com/profile">{{ $t('clickHere') }}</a>.</p>
          <br v-if="brokerProblem">
          <p v-if="assetProblem && brokerProblem"><font v-html="$t('alsoNotAsset')"/>
            <a class="ml-1" href="https://app.swiset.com/watchlist">{{ $t('clickHere') }}</a>.</p>
          <p v-else-if="assetProblem"><font v-html="$t('notAsset')"/>
            <a class="ml-1" href="https://app.swiset.com/watchlist">{{ $t('clickHere') }}</a>.</p>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        name: "NotAllowed",
        data() {
            return {
                brokerProblem: false,
                assetProblem: false,
            };
        },
        mounted() {
            this.assetProblem = (this.$store.state.user.assets.length === 0);
            this.brokerProblem = (this.$store.state.user.brokerAccounts.length === 0);
        },
        methods: {
            closeWindow(){
                this.$emit('closeWindow');
            }
        }
    }
</script>

<i18n>
{
  "en": {
    "title": "You cannot create a trade",
    "notBrokerAccount": "You currently <b>do not have associated broker accounts</b>,<br>please associate at least one by",
    "notAsset": "You currently <b>do not have associated assets</b>,<br>please associate at least one by",
    "alsoNotAsset": "Also, <b>you do not have</b> associated assets,<br>please associate at least one by",
    "clickHere": "clicking here"
  },
  "es": {
    "title": "No puedes crear un trade",
    "notBrokerAccount": "Actualmente<b> no tienes ninguna cuenta de broker creada</b>,<br>por favor crea al menos una",
    "notAsset": "Actualmente<b> no tienes activos asociados</b>,<br>por favor asocia al menos una",
    "alsoNotAsset": "<b>Tampoco tienes</b> activos asociados,<br>por favor asocia al menos una",
    "clickHere": "dando click aquí"
  }
}
</i18n>

<style scoped>
.no-trades {
  color: #111111;
  font-size: 70px;
}
</style>
